import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type transactionDataType = {
  id: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({ id, errorCallback, resultKey = 'transactionData' }: transactionDataType) =>
  requestAsync({
    url: endpoints.getTransactionUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getTransactionUrl(id)}`,
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
